module.exports = __webpack_public_path__ + "static/media/fuel.212f9810.svg";